import { toast } from "react-toastify";

/**
 * Wrap Axios call with automatic toast handling
 * @param {Function} axiosCall - function returning axios promise
 * @param {string} toastId - toastId to use for loading/update
 * @param {object} tokenData - optional tokens for getLabel ({name, email, etc.})
 * @param {Function} getLabel - function to translate the labels
 * @returns {Promise<any>} - response data
 */
export const toastAxios = async (
  axiosCall,
  toastId,
  tokenData = {},
  getLabel
) => {
  // mostra il toast loading
  toast.loading(getLabel("toast_inProgress"), {
    toastId,
    type: toast.TYPE.INFO,
    position: toast.POSITION.BOTTOM_RIGHT,
    exclude: true,
  });

  try {
    const response = await axiosCall();

    // gestione success/error basata su server
    if (response?.success) {
      toast.update(toastId, {
        render: getLabel(response.success, tokenData),
        type: toast.TYPE.SUCCESS,
        isLoading: false,
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 4000,
      });
    } else {
      // fallback error
      toast.update(toastId, {
        render: getLabel(response?.error || "toast_errorGeneric", tokenData),
        type: toast.TYPE.ERROR,
        isLoading: false,
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 5000,
      });
    }

    return response;
  } catch (e) {
    console.error(e);
    const status = e?.response?.status;
    const data = e?.response?.data;
    let message = "toast_errorGeneric"; // fallback

    if (status === 401) message = getLabel("toast_unauthorized", tokenData);
    else if (status === 403) message = getLabel("toast_forbidden", tokenData);
    else if (status === 404) message = getLabel("toast_notFound", tokenData);
    else if (status === 422 && data?.errors) {
      message = Object.values(data.errors)
        .flat()
        .map((err) => getLabel(err, tokenData))
        .join("\n");
    } else if (data?.error) {
      console.log('data?.error', data?.error, 'status', status)
      message = getLabel(data.error, tokenData);
      // Se la traduzione non viene trovata, usa error_message come fallback
      if (message.startsWith('#') && data?.error_message) {
        message = data.error_message;
      }
    }

    toast.update(toastId, {
      render: message,
      type: toast.TYPE.ERROR,
      isLoading: false,
      position: toast.POSITION.BOTTOM_RIGHT,
      autoClose: 5000,
    });

    return null;
  }
};
